<template>
	<div class="report-layout__section">
		<h5 class="report-layout__title">
			{{ title }}
		</h5>
		<section-row
			v-for="(columns, index) in rows"
			:key="index"
			:columns="columns"
			class="tile is-ancestor"
			:hospital-id="hospitalId"
			:listing-id="listingId"
			:organisation-id="organisationId"
		></section-row>
	</div>
</template>

<script>
import SectionRow from "./ReportSectionRow";
export default {
	name: "ReportSection",
	components: {
		SectionRow
	},
	props: {
		section: {
			type: Object,
			default: () => null
		},
		hospitalId: {
			type: Number,
			default: () => null
		},
		listingId: {
			type: Number,
			default: () => null
		},
		organisationId: {
			type: Number,
			default: () => null
		}
	},
	computed: {
		title() {
			return this.section.title;
		},
		rows() {
			return this.section.rows;
		}
	}
};
</script>

<style lang="scss">
.report-layout {
	&__section {
		margin-bottom: 1.875em;
		padding-bottom: 1rem;
		// border-bottom: 1px solid $border;

		&:first-child {
			margin-top: 2.875rem;
		}
	}
	&__title {
		font-size: 1.5rem;
		font-weight: 700;
		margin-bottom: 1rem;
	}
}
</style>
